import React from 'react'
import { Card, CardBody } from 'reactstrap'
import { MdOutlinePeopleAlt } from "react-icons/md";
import RecentEntryCard from './RecentEntryCard';

function RecentEntryDetections() {
  return (
    <>
    <Card>
        <CardBody>
            {/* ..............recent entry detections heading............ */}

            <div className="d-flex  align-items-center mb-3 gap-2">
                <MdOutlinePeopleAlt  style={{fontSize:"20px"}}/>
                <h2 className='py-3' style={{fontSize:"18px" , fontWeight:"600" ,color:"#1D67AA", margin:"0px" }}>Recent Entry Detections</h2>
            </div>

            {/* ..............recent entry detections cards............ */}

            <RecentEntryCard
            backgroundcolor="#1D67AA"
            color="#FAFAFA"
            recbadge="Recognized "
            time="11:23:45 AM"
            post="Senior Developer"
            employName="ALi Muhmmad "
            confidence="98.5% confidence"


            
            
            />
            <RecentEntryCard
            backgroundcolor="#EF4444"
            color="#FAFAFA"
            recbadge="Unknown "
            time=" 11:20:12 AM"
            post="Unidentified"
            employName="Unknown Person"
            confidence=""

            
            
            /><RecentEntryCard
            backgroundcolor="#1D67AA"
            color="#FAFAFA"
            recbadge="Recognized "
            time="11:18:33 AM"
            post="Project Manager"
            employName="Mirza ijlal"
            confidence="96.5% confidence"


            
            
            />
            
            



        </CardBody>
    </Card>
    
    
    </>
  )
}

export default RecentEntryDetections